export default {
    in: {
        from: {
            transform: `translateY(-100px)`,
        },
        to: {
            transform: '',
        },
    },

    out: {
        from: {
            transform: 'translateY(0)',
        },
        to: {
            transform: `translateY(-100px)`,
        },
    },
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/animations/slide-down/index.js